export default (type, title, body) => {
  const event = new CustomEvent('search:pushNotification', {
    detail: {
      type,
      title,
      body,
    },
  });
  window.dispatchEvent(event);
};
